import * as React from 'react';
import classnames from 'classnames';

type Props = {
    title: string;
    id: string;
    children: React.ReactNode;
};

const PageFooterBlock: React.FC<Props> = ({ title, children, id }) => (
    <div className={classnames('page-footer__block', { [id]: id! })}>
        <div className="page-footer__block-label">
            <span>{title}</span>
        </div>

        <div className="page-column__block-cotent">{children}</div>
    </div>
);

export default PageFooterBlock;
